export default __webpack_public_path__ + "static/media/no-actions.99921e51.svg";